<template>
    <!--<img src="../../assets/guanyin.jpg" class="portrait_guanyin"/>-->
    <div style="" class="portrait_guangong_box">
        <div class="portrait_guangong_ring"></div>
        <div class="portrait_guangong"></div>
    </div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    export default {
        name: 'GuanYuPortrait',
        props: {},
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .portrait_guangong_box{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .portrait_guangong {
        position: absolute;
        width: 98%;
        height: 98%;
        background-image: url("~@/assets/guangong.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }

    .portrait_guangong_ring {
        position: absolute;
        width: 30%;
        height: 30%;
        border: 1px solid black;
        border-radius: 50%;

        animation-name: animation1;
        animation-duration: 0.5s;
        /*animation-timing-function: linear;*/
        animation-direction: alternate;
        animation-iteration-count: infinite;
    }

    @keyframes animation1 {
        0% {
            width: 30%;
            height: 30%;
            top:7%;
            right: 32%;
        }

        100% {
            width: 32%;
            height: 32%;
            top:6%;
            right: 31%;
        }
    }
</style>